import { Tab } from "@headlessui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import {
  c1,
  c1_ar,
  c2,
  c2_ar,
  c3,
  c3_ar,
  c4,
  c4_ar,
  c5,
  c5_ar,
  c6,
  c6_ar,
  c7,
  c7_ar,
  c8,
  c8_ar,
  c9,
  c9_ar,
  c10,
  c11,
  c11_ar,
  c10_ar,
} from "../../constant/images";

const servicesImagesEn = [c1, c2, c3, c4, c5, c6, c7, c8, c9, c10, c11]; // Use existing images in a loop
const servicesImagesAr = [
  c1_ar,
  c2_ar,
  c3_ar,
  c4_ar,
  c5_ar,
  c6_ar,
  c7_ar,
  c8_ar,
  c9_ar,
  c10_ar,
  c11_ar,
]; // Use existing images in a loop

const FilteredCourse = ({ classNameForTabOne }) => {
  const { t, i18n } = useTranslation();

  const isArabic = i18n.language === "ar";
  const servicesImages = isArabic ? servicesImagesAr : servicesImagesEn;

  const services = Object.keys(t("services", { returnObjects: true })).map(
    (key, index) => ({
      title: t(`services.${key}.title`),
      description: t(`services.${key}.description`),
      img: servicesImages[index % servicesImages.length],
    })
  );

  return (
    <Tab.Group>
      <Tab.Panels as="div" id="tabs-content">
        <Tab.Panel as="div" id="tab1" className="tab-content">
          <div className={classNameForTabOne}>
            {services.map((item, index) => (
              <div
                key={index}
                className="bg-white shadow-box2 rounded-[8px] transition duration-100 hover:shadow-sm"
              >
                <div className="course-thumb h-[248px] rounded-t-[8px] relative">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover rounded-t-[8px]"
                  />
                </div>
                <div className="course-content p-8">
                  <h4 className="text-xl mb-3 font-bold">{item.title}</h4>
                  <p className="text-gray-600">{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </Tab.Panel>
      </Tab.Panels>
    </Tab.Group>
  );
};

export default FilteredCourse;
